import {CustomTagsGateway} from "@livechat/tags";
import {UseCase} from "@livechat/shared";
import {Observable} from "rxjs";

export class DeleteTagUseCase implements UseCase<{ id: number }, Observable<void>> {
  constructor(private tagsGateway: CustomTagsGateway) {
  }

  execute(params: { id: number }): Observable<void> {
    return this.tagsGateway.remove(params.id)
  }
}
